// Client-side analytics utilities

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    lintrk?: (action: string, params: any) => void;
  }
}

/**
 * Tracks a custom event in Google Analytics
 */
export const trackGAEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

/**
 * Tracks a conversion event in Google Ads
 */
export const trackGoogleAdsConversion = (value?: number, currency?: string) => {
  const adsId = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID;
  const label = process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL;

  if (adsId && label && typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: `${adsId}/${label}`,
      value: value ?? 1.0,
      currency: currency ?? 'USD',
    });
  }
};

/**
 * Tracks a conversion event in LinkedIn Insight
 */
export const trackLinkedInConversion = (conversionId?: string | number) => {
  const defaultConversionId = process.env.NEXT_PUBLIC_LINKEDIN_CONVERSION_ID;
  const targetId = conversionId || defaultConversionId;

  if (targetId && typeof window !== 'undefined' && typeof window.lintrk === 'function') {
    window.lintrk('track', { conversion_id: Number(targetId) });
  }
};
